import * as Yup from 'yup'
import { isAfter, isEqual } from 'date-fns'

export const START_DATE = 'start_date'
export const END_DATE = 'end_date'

export const startEndDateRangeInitialValues = {
  [START_DATE]: '',
  [END_DATE]: ''
}

export const endDateReusableValidation = Yup.string().when(START_DATE, {
  is: val => !!val,
  then: () =>
    Yup.string().test(END_DATE, `The end date must not be earlier than the start date`, (value, { parent }) => {
      if (value) {
        // when START_DATE and END_DATE is selected
        const startDate = new Date(parent[START_DATE])
        const endDate = new Date(value)
        return isAfter(endDate, startDate) || isEqual(startDate, endDate)
      } else {
        // when only START_DATE is selected(case when END_DATE is empty
        return true
      }
    })
})

export const startDateValidation = Yup.string().required('Please select start date')
export const endDateValidation = endDateReusableValidation.required('Please select end date')

export const startEndDateRangeFieldsValidation = {
  [START_DATE]: startDateValidation,
  [END_DATE]: endDateValidation
}
